// extracted by mini-css-extract-plugin
module.exports = {"loader":"PastPerformanceBlock_loader__JSXm9","chart-description":"PastPerformanceBlock_chart-description__qz60B"};